import { useTheme } from '@mui/material';
import type { Theme } from '@mui/system';

import GoogleIconColored from './svg/googleIconColored.svg';
import GoogleIconMono from './svg/googleIconMono.svg';

export enum EMlpIconVariant {
	Primary = 'PRIMARY',
	PrimaryVariation = 'PRIMARY_VARIATION',
	Secondary = 'SECONDARY',
	Disabled = 'DISABLED',
	BrandColors = 'BRAND_COLORS',
}

export interface IGoogleIconProps {
	variant?: EMlpIconVariant;
	size?: number;
}

const getSingleColor = (variant: EMlpIconVariant, theme: Theme): string => {
	switch (variant) {
		case EMlpIconVariant.Primary:
			return theme.palette.primary.main;
		case EMlpIconVariant.PrimaryVariation:
			return theme.palette.solutions[600];
		case EMlpIconVariant.Secondary:
			return theme.palette.neutral.main;
		case EMlpIconVariant.Disabled:
			return theme.palette.solutions[800];
		default:
			return theme.palette.primary.main;
	}
};

export const GoogleIcon = ({
	variant = EMlpIconVariant.BrandColors,
	size = 24,
}: IGoogleIconProps) => {
	const theme = useTheme();

	if (variant === EMlpIconVariant.BrandColors) {
		return (
			<GoogleIconColored
				width={size}
				height={size}
				style={{ display: 'block' }}
			/>
		);
	}

	const color = getSingleColor(variant, theme);
	return (
		<GoogleIconMono
			width={size}
			height={size}
			style={{ display: 'block' }}
			fill={color}
		/>
	);
};
